import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-admin-offices-edit',
  templateUrl: './admin-offices-edit.component.html'
})
export class AdminOfficesEditComponent implements OnChanges, OnInit {
  @Input() formdata;
  @Input() roles;
  @Input() types;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  form;
  
  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      id: ['', ''],
      abbreviation: ['', ''],
      name: ['', ''],
      officeTypeId: ['', ''],
      officeTypeName: ['', ''],
      sort: ['', ''],
      email: ['', ''],
      isActive: [null, ''],
      roleId: ['', ''],
      roleDescription: ['', '']
    });
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.formdata.currentValue) {
      this.form?.patchValue(changes?.formdata.currentValue);
    }
  }

  setRole(evt) {
    this.form.patchValue({ roleId: evt.value });
  }

  setType(evt) {
    this.form.patchValue({ officeTypeId: evt.value });
  }

  saveOffice() {
    this.doSave.emit(this.form.value);
  }

  cancel() {
    this.doCancel.emit();
  }
}
